import { Container, Button,Form, Alert,Table} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "./ContentStyles";
import {Pageheight} from "../index";
import React, {useMemo, useState, useEffect } from 'react';
import GlobalCSS from "../App.css";
import useBackend, {CallAPI,  Loading, SpinnerX, Check} from '../services/useBackend';
import {useNavigate} from 'react-router';

// import { MaterialReactTable } from 'material-react-table';

export default function MyComponent() {
    const {resultVariant, resultVisible, resultText, loading, data} =  useBackend('/backend/contacts');

    const navigate = useNavigate();

    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });

    useEffect(() => { navigate('?pageindex='+pagination.pageIndex+'&pagesize='+pagination.pageSize) }, [pagination]);

    const detailShopClick = async (event, rowData)  =>  {

    }    

    const columns = useMemo(() => [
        { size: 100, accessorKey: 'Name', header: 'Description' },
        { size: 100, accessorKey: 'ChipID', header: 'ChipID' },
        { size: 100, accessorKey: 'IOTConnection.Reconnections', header: 'Reconnections' },
        { size: 100, accessorKey: 'IOTConnection.RSSI',     header: 'RSSI' },                    
        {
            size: 20, header: 'Online', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ row }) => (<Check checked={row.original.IOTConnection.Online} />),
        },             
      ]
    );  

    const initialState = 
    { 
        density: 'compact',
        columnVisibility: { Company: false, Description:true }, 
        pagination : pagination 
    };  

    const state = { pagination : pagination };     

    if (!loading) {
        return (
            <ContentWrapper>
                <Container>
                    <Sida style={{minHeight:Pageheight(400)}}>
                    <Rubrik>Crm (Contacts)</Rubrik>
                    <StyckeCompact>
                        <Table  responsive="sm" class={GlobalCSS.gridtable}>
                            <thead>
                                <tr>    <td>Namn</td><td>Subunit</td><td>Zip/City</td> </tr>
                            </thead>
                            <tbody>
                                {data.contacts.map((item) => {
                                    return <tr><td>{item.name}</td> <td>{item.subunit}</td> <td>{item.zip} {item.city}</td> </tr>
                                })}
                            </tbody>
                        </Table>
                    </StyckeCompact>  

                    <Form >
                        <Form.Group className="mb-3"  hidden={!loading}>
                            <SpinnerX  />
                        </Form.Group>                                      
                            
                        <Form.Group className="mb-3"  hidden={!resultVisible}>
                            <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Button className="CloudButton" variant="primary" type="submit">New product</Button>
                        </Form.Group>                                
                    </Form>                 
                </Sida>
                </Container>

                {/* <Container>
                    <Sida>                    
                        <MaterialReactTable  columns={columns} data={data.contacts} 
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false ,labelRowsPerPage:"Rader", rowsPerPageOptions: [25, 50, 100]}}
                            renderTopToolbarCustomActions={() => (<Rubrik>Uppkopplade Enheter</Rubrik>)} initialState={initialState} onPaginationChange={setPagination} state={state} 
                                muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                                
                                muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        detailShopClick(event, row);
                                    },
                                    sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                })}
                        />                                            
                    </Sida>
                </Container>                 */}
            </ContentWrapper>
        );
    } else {
        return (
            <ContentWrapper>
                <Container>
                    <Sida style={{minHeight:Pageheight(400)}}>
                        <Rubrik>Loading Crm (Contacts)</Rubrik>
                        <SpinnerX  />
                    </Sida>
                </Container>
            </ContentWrapper>
        );        
    }    
};